

import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import moment from 'moment';


const stateEnum = {
  IDLE: 'IDLE',
  CHATROOM_LOADING: 'CHATROOM_LOADING',
  SENDING_MESSAGE: 'SENDING_MESSAGE',
  CHATROOM_REFRESHING: 'CHATROOM_REFRESHING',
}
const module = {
  state: {
    messages: [],
    state: stateEnum.IDLE,
    messagesLoaded: false,
    roomInfo:{
      rel_model: 'chatroom',
      rel_id: 1,
    },
    nextRefreshTime: null,
  },

  getters: {
    lastMessage(state) {
      if (state.messages.length > 0) {
        return state.messages[0];
      }
      return null
    }
  },

  mutations: {
    APPEND_MESSAGES(state, messages) {
      const newList =  [
        ...messages,
        ...state.messages
      ]
      // loop through messages and remove duplicates
      const keyIDs = {}
      for( const msg of newList) {
        if (keyIDs[msg.id]) {
          // if the message id already exists, remove it from the list
          const index = newList.indexOf(msg);
          if (index > -1) {
            newList.splice(index, 1);
          }
        } else{
          // if the message id does not exist, add it to the keyIDs
          keyIDs[msg.id] = true;
        }
      }

      state.messages = newList;
    }
  },

  actions: {
    async initChatroom({ state,commit }) {
      commit('setState', {
        state: stateEnum.CHATROOM_LOADING,
        nextRefreshTime: null,
      });
      const result = await $this.$api.postData({
        data: {
          getChatroomMessages: { api: 'X0001ChatService.Chatroom_getChatroomMessages', input:
            {
              ...state.roomInfo,
              _last_message_id: 0
            }
          }
        }
      });
      commit('setState', {
        messages: result.getChatroomMessages.output.rows,
        state: stateEnum.IDLE,
        nextRefreshTime: moment().add(5, 'seconds'),
      });
    },
    async sendMessage({ state,commit,dispatch,getters },detail) {
      commit('setState', {
        state: stateEnum.SENDING_MESSAGE,
        nextRefreshTime: null,
      });
      const {
        content
      } = detail;
      console.log(detail);

      const newMsg={
        ...state.roomInfo,
        content
      }

      const result = await $this.$api.postData({
        data: {
          sendMessage: {
            api: 'X0001ChatService.Chatroom_sendMessage',
            input: {
              message: newMsg
            }
          },
          getChatroomMessages: { api: 'X0001ChatService.Chatroom_getChatroomMessages', input:
            {
              ...state.roomInfo,
              _last_message_id: getters.lastMessage?.id || 0
            }
          }
        }
      },false);

      commit('APPEND_MESSAGES', result.getChatroomMessages.output.rows);
      commit('setState', {
        state: stateEnum.IDLE,
        nextRefreshTime: moment().add(10, 'seconds'),
      });
    },
    async refreshChatroom({ state, commit,getters }) {
      if(state.state !== stateEnum.IDLE) return
      console.log('refreshChatroom next', moment.duration(state.nextRefreshTime.diff()).seconds());
      if ( state.nextRefreshTime
        && moment() < moment(state.nextRefreshTime)) {
        return;
      }
      commit('setState', {
        state: stateEnum.CHATROOM_REFRESHING,
        nextRefreshTime:0
      });
      const result = await $this.$api.postData({
        data: {
          getChatroomMessages: { api: 'X0001ChatService.Chatroom_getChatroomMessages', input:
            {
              ...state.roomInfo,
              _last_message_id: getters.lastMessage?.id || 0
            }
          }
        }
      },false);
      commit('APPEND_MESSAGES', result.getChatroomMessages.output.rows);
      commit('setState', {
        state: stateEnum.IDLE,
        nextRefreshTime: moment().add(30, 'seconds'),
      });
    },
  }
}

export default ObjArrUtils.merge(Base, module)
